import React from "react";
import { withTranslation } from "react-i18next";

import QuestionResultStatus from "../../../QuestionResultStatus";
import { QUESTION_RESULT_STATUS } from "../../../../../../util/common";

import "./index.scss";

const LegendItem = ({ label, status }) => {
  return (
    <span className="legend-item">
      <span className="legend-text">{label}</span>
      <QuestionResultStatus status={status} />
    </span>
  );
};

const Legend = ({ t }) => {
  return (
    <div className="legend">
      <span className="legend-title">{t("cc_legend").message || "Legend"}</span>
      <LegendItem label="N/A" status={QUESTION_RESULT_STATUS.NOT_WORKED_ON} />
      <LegendItem label={t("cc_necessary").message || "Necessary"} status={QUESTION_RESULT_STATUS.NECESSARY} />
      <LegendItem label={t("cc_advice").message || "Advice"} status={QUESTION_RESULT_STATUS.ADVISED} />
      <LegendItem label="Ok" status={QUESTION_RESULT_STATUS.OK} />
      <LegendItem label={t("cc_ok_with_remark").message || "Ok with remark"} status={QUESTION_RESULT_STATUS.OK_WITH_REMARKS} />
    </div>
  );
};

export default withTranslation()(Legend);
